<div
  [ngClass]="[mainPhotoContainer.uId, 'm' + mainPhotoContainer.modelId]"
  class="full-screen-container"
>
  <div
    (click)="previousImage()"
    *ngIf="images.length > 1"
    [ngClass]="[leftArrow.uId, 'm' + leftArrow.modelId]"
    [item]="leftArrow"
    [ngStyle]="leftArrowAdditionalStyle"
    (keydown.enter)="previousImage()"
    [appClickableBlock]="leftArrow"
    app-block
    class="left-arrow"
  ></div>

  <div [class]="photoContainer.uId" class="photo-container">
    <div
      (mousedown)="mouseDown($event)"
      (mousemove)="mouseMove($event)"
      (mouseup)="mouseUp()"
      (touchend)="mouseUp()"
      (touchmove)="mouseMove($event)"
      (touchstart)="mouseDown($event)"
      [class.grabbing]="shifting || isMouseDownOnImage"
      [class.no-transition]="shifting || isMouseDownOnImage"
      [ngStyle]="imageContainerStyle"
      class="images-handler"
    >
      <div
        *ngFor="let photo of images; let i = index"
        [ngStyle]="imageHandlerStyle"
        class="image-handler"
      >
        <div class="handler">
          <div *ngIf="getPhotoBlock(photo) as photoBlock" style="width: 100%;">
            @if ((photoBlock.media ?? photoBlock.image)) {
              @if ((photoBlock.media ?? photoBlock.image)?.urls?.full?.includes('mp4')) {
                <div>
                  <app-lightbox-preview-video
                    #videoPlayer
                    [class]="photoBlock.uId"
                    [photo]="photoBlock"
                    [urls]="(photoBlock.media ?? photoBlock.image)?.urls"
                  ></app-lightbox-preview-video>
                </div>
              } @else {
                <app-lightbox-preview-image
                  (isZoomedImage)="setIsZoomed($event)"
                  [ngClass]="[photoBlock.uId, 'm' + photoBlock.modelId]"
                  [photo]="photoBlock"
                >
                </app-lightbox-preview-image>
              }
            } @else {
              <div
                [ngClass]="[photoBlock.uId, 'm' + photoBlock.modelId]"
                [item]="photoBlock"
                app-block
                [disableTabIndex]="true"
              ></div>
            }
          </div>

          <div class="standard-blocks">
            @for (child of getStandardBlocks(photo); track child) {
              <div
                [ngClass]="[child.uId, 'm' + child.modelId]"
                [item]="child"
                app-block
                [disableTabIndex]="true"
              ></div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    [ngClass]="[rightArrowContainer.uId, 'm' + rightArrowContainer.modelId]"
    class="right-arrow-container"
  >
    <div
      (click)="closePreview()"
      [ngClass]="[closeIcon.uId, 'm' + closeIcon.modelId]"
      [item]="closeIcon"
      [appClickableBlock]="closeIcon"
      (keydown.enter)="closePreview()"
      app-block
      class="close-icon"
    ></div>
    @if (images.length > 1) {
      <div
        (click)="nextImage()"
        [ngClass]="[rightArrow.uId, 'm' + rightArrow.modelId]"
        [item]="rightArrow"
        [appClickableBlock]="rightArrow"
        (keydown.enter)="nextImage()"
        app-block
        class="right-arrow"
      ></div>
    }
    <div
      [ngClass]="[emptyBlock.uId, 'm' + emptyBlock.modelId]"
      [item]="emptyBlock"
      app-block
    ></div>
  </div>
</div>
